import React from 'react';
import PropTypes from 'prop-types';
import { createURL } from '@sm/utils';
import { Box } from '@wds/box';
import { Card } from '@wds/card';
import { Typography } from '@wds/typography';
import AppPlaceHolderImg from '~app/pages/AppsDirectory/static/images/app-placeholder.png';
import { trimStringTo } from '~app/pages/AppsDirectory/components/utils';
import useStyles from './styles';

const AppCard = ({ app }) => {
  const { appCardLogo } = useStyles();
  const href = createURL(app.link);

  return (
    <Card data-testid="AppCard__Col" key={app.encryptedAppId} href={href}>
      <Card.Preview>
        <Box mb={5}>
          <img src={app.image ? app.image : AppPlaceHolderImg} alt={app.name} className={appCardLogo} />
        </Box>
      </Card.Preview>
      <Card.Header>
        <Typography variant="cardTitle" weight="medium">
          {app.name}
        </Typography>
      </Card.Header>
      <Card.Body>
        <Typography>{trimStringTo(85, app.tagline)}</Typography>
      </Card.Body>
    </Card>
  );
};

AppCard.propTypes = {
  app: PropTypes.shape({
    encryptedAppId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    tagline: PropTypes.string.isRequired,
    image: PropTypes.string,
    link: PropTypes.string.isRequired,
  }).isRequired,
};

export default AppCard;
